import { render } from "./action-button.vue?vue&type=template&id=635bbdd2&scoped=true"
import script from "./action-button.vue?vue&type=script&lang=js"
export * from "./action-button.vue?vue&type=script&lang=js"

import "./action-button.vue?vue&type=style&index=0&id=635bbdd2&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635bbdd2"]])

export default __exports__